export function createHeroesArray() {
  const heroImages = [...document.querySelectorAll('.c-hero__unit--2')]
  const heroText = [...document.querySelectorAll('.c-hero__unit--3')]
  const herosArray = []

  for (let i = 0; i < heroImages.length; i++) {
    const hero = {
      image: heroImages[i],
      text: heroText[i],
    }
    herosArray.push(hero)
  }
  return herosArray
}

/* export function lazyLoadHeroImages() {
  document.addEventListener('DOMContentLoaded', () => {
    const lazyImages = [...document.querySelectorAll('.c-hero__unit--2 > img')]
    lazyImages.forEach((image) => {
      if (image.dataset.picture.length > 3) {
        image.setAttribute('src', image.dataset.picture)
      }
    })
    // console.log(lazyImages)
  })
} */
